var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerksColor = function SvgPerksColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 80,
    fill: "none",
    viewBox: "0 0 74 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B36C",
    d: "M18.48 74.824c17.396 10.044 39.64 4.083 49.684-13.313s4.083-39.64-13.313-49.683C37.455 1.784 15.211 7.745 5.168 25.141-4.876 42.537 1.084 64.78 18.48 74.824",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B36C",
    d: "M46.375 43.894c-3.651-1.817-7.246-7.436-13.331-7.464-8.609-.04-8.645 4.371-14.36 7.534l8.074 13.989a2.53 2.53 0 0 0 2.19 1.263H45.1c.9 0 1.737-.48 2.189-1.263l6.884-11.924s-4.11-.296-7.8-2.135m-15.186 3.257a2.102 2.102 0 1 1 2.105-3.64 2.102 2.102 0 0 1-2.105 3.64m12.205 4.563-2.31.618a.17.17 0 0 0-.117.115l-.682 2.292c-.05.161-.283.16-.324-.004l-.619-2.31a.17.17 0 0 0-.113-.12l-2.292-.682c-.163-.048-.16-.28.005-.324l2.31-.619a.17.17 0 0 0 .116-.115l.683-2.291c.05-.162.28-.157.326.006l.614 2.31c.018.057.06.1.115.117l2.292.683c.164.052.16.282-.004.324M46.812 35.844l2.31-.62c.165-.043.166-.275.004-.323l-2.292-.682a.17.17 0 0 1-.115-.117l-.619-2.31c-.044-.165-.276-.167-.323-.004l-.683 2.292a.17.17 0 0 1-.117.114l-2.31.62c-.165.044-.167.276-.004.323l2.292.683a.17.17 0 0 1 .115.116l.619 2.31c.044.165.276.167.323.004l.683-2.291a.17.17 0 0 1 .117-.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.361,
    d: "m43.302 19.555 4.532-7.848a3.36 3.36 0 0 1 4.591-1.23l4.806 2.774a3.363 3.363 0 0 1 1.23 4.592l-4.53 7.848a3.37 3.37 0 0 0 0 3.361l7.194 12.46c.599 1.04.6 2.322 0 3.361L50.389 63.47a3.37 3.37 0 0 1-2.911 1.68l-21.476.002a3.36 3.36 0 0 1-2.911-1.68L12.356 44.871a3.37 3.37 0 0 1 0-3.361l10.736-18.596a3.37 3.37 0 0 1 2.91-1.68h14.388a3.37 3.37 0 0 0 2.911-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.361,
    d: "M60.142 14.934 49.513 8.798l1.016-4.832a2.69 2.69 0 0 1 3.976-1.776l8.86 5.116a2.688 2.688 0 0 1 .45 4.33l-3.676 3.296z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h73.277v80H0z"
  })))));
};
export default SvgPerksColor;